import * as React from 'react';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { Messages } from '../../../../codegen/Localize';
import { CommonStyles } from '../../../../common/react/CommonStyles';
import { cssClass } from '../../../../style';
import { SortableHeader } from '../../../../common/react/components/dataGrid/SortableHeader';

const rowHeight = '39px';
const cssPrefix = 'DataroleValuesAndSynonymsHeader';
const headerStyle =  cssClass(cssPrefix, 'header', {
  borderBottom: '1px solid rgb(235, 235, 235)',
  height: rowHeight,
  lineHeight: rowHeight,
  color: '#333',
  fontSize: '13px',
});

const valueStyle =  cssClass(cssPrefix, 'value', {
  paddingLeft: CommonStyles.Sizes.MediumSpace,
  display: 'inline-block',
  boxSizing: 'border-box',
  cursor: 'pointer',
  fontWeight: 'bold',
  $nest: {
    '&:hover': {
      backgroundColor: '#F5F5F5',
      textDecoration: 'underline',
    },
  }
});

const cellStyle =  cssClass(cssPrefix, 'value', {
  paddingLeft: CommonStyles.Sizes.MediumSpace,
  display: 'inline-block',
  boxSizing: 'border-box',
  fontWeight: 'bold',
});

export interface ValuesAndSynonymsHeaderProps {
  readonly ascending: boolean;
  setAscending: (ascending: boolean) => void;
}

export const ValuesAndSynonymsHeader: React.FC<ValuesAndSynonymsHeaderProps> = (props: ValuesAndSynonymsHeaderProps) => {
  const [sorted, setSorted] = React.useState(false);

  const onClick = () => {
    props.setAscending(!props.ascending);
    if (!sorted) {
      setSorted(true);
    }
  };

  return (
  <div className={headerStyle}>
    <div className={valueStyle} style={{width: '33%'}} onClick={onClick}><SortableHeader.ArrowIcon sorted={sorted} ascending={props.ascending}/>{Messages.dataRoleDefinitionSubspace_Values_Name()}</div>
    <div className={cellStyle} style={{width: '67%'}}>{Messages.dataRoleDefinitionSubspace_Values_Synonyms()}</div>
  </div>
  );
};

